<template>
    <v-dialog
        v-model="printTicketsDialog"
        :fullscreen="$vuetify.breakpoint.xs"
        persistent
        width="500"
    >
        <template v-slot:activator="{ on, attrs }">
            <v-icon
                class="material-icons-outlined mr-7"
                v-bind="attrs"
                :disabled="printDisabled"
                @click="print"
            >
                print
            </v-icon>
        </template>
        <v-card id="print-tickets-dialog">
            <v-card-title class="text-h5 lighten-2">
                <v-icon
                    class="material-icons-outlined"
                    color="primary"
                >
                    print
                </v-icon>
                <span>Print ({{ selectedTickets.length }}) to PDF</span>
            </v-card-title>
            <v-divider />
            <v-card-text
                :class="[$vuetify.breakpoint.xs ? 'custom-mobile-text-area' : '', ($vuetify.breakpoint.xs && submitted) ? 'd-flex justify-center align-center' : '']"
            >
                <div v-if="!isLoading && !submitted">
                    <div class="control-title">
                        Format
                    </div>
                    <v-select
                        v-model="format"
                        :items="selectPrintOptions"
                        item-text="name"
                        item-value="value"
                        outlined
                        dense
                        label="Format"
                        class="custom-dropdown"
                    />
                    <div
                        class="control-title"
                        style="margin-top: 0px"
                    >
                        Map Image
                    </div>
                    <v-radio-group v-model="map">
                        <v-radio
                            v-for="n in radioOptions"
                            :key="n.value"
                            :label="n.name"
                            :value="n.value"
                        />
                    </v-radio-group>
                </div>
                <div
                    v-if="isLoading && submitted"
                    class="text-center"
                    style="margin: 32px 0px;"
                >
                    <v-progress-circular
                        :size="50"
                        color="primary"
                        indeterminate
                    />

                    <div class="control-title">
                        Please wait while your PDF is being generated
                    </div>
                </div>
                <div
                    v-if="!isLoading && submitted"
                    class="text-center"
                    style="margin: 32px 0px;"
                >
                    <v-icon color="green">
                        check_circle
                    </v-icon>
                    <div class="control-title">
                        Completed Successfully
                    </div>
                    <v-list-item
                        three-line
                        style="background-color: var(--ll-surface-subtle)"
                        class="custom-list-item d-flex justify-space-between align-center"
                        :style="{'width': $vuetify.breakpoint.xs ? '90vw': ''}"
                    >
                        <v-list-item-content class="d-flex justify-space-between align-center">
                            <div style="max-width: 20%;">
                                <PdfIcon />
                            </div>
                            <div
                                style="max-width: 80%;"
                                class="text-start"
                            > 
                                <b>{{ printTicketsResponse.task_output_ref }}</b>
                            </div>
                        </v-list-item-content>
                        <v-btn
                            style="text-transform: none !important"
                            depressed
                            color="primary"
                            @click="openPDFURL"
                        >
                            Open
                        </v-btn>
                    </v-list-item>
                </div>
            </v-card-text>
            <v-divider />
            <v-card-actions>
                <v-spacer />
                <v-btn
                    style="text-transform: none !important"
                    outlined
                    light
                    :width="$vuetify.breakpoint.xs ? '50%' : ''"
                    @click="closeDialog"
                >
                    Cancel
                </v-btn>
                <v-btn
                    v-if="!isLoading && !submitted"
                    style="text-transform: none !important"
                    depressed
                    color="primary"
                    :width="$vuetify.breakpoint.xs ? '50%' : ''"
                    @click="printTicket"
                >
                    Print
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>    
</template>
<script>
import webtmsBackend from '@/services/webtmsBackend';
import constants from '../constants';
import PdfIcon from '@/components/CustomIcons/PdfIcon';

const NEWTIN_HOST = constants.NEWTIN_DOMAIN || '';
export default {
    components: {
        PdfIcon,
    },
    props: {
        selectedTickets: {
            type: Array,
            default: () => ([]),
        },
    },
    data: () => ({
        printTicketsDialog: false,
        selectPrintOptions: [
            { name: 'Original text', value: 'ORIGINAL' },
            { name: 'Alert email', value: 'ALERT_EMAIL' },
            { name: 'Alert SMS', value: 'ALERT_SMS' },
            { name: 'Company', value: 'COMPANY_1' }
        ],
        radioOptions: [
            { name: 'With imagery', value: 'map-ortho' },
            { name: 'Without imagery', value: 'map-no-ortho' },
            { name: 'No', value: 'no' }
        ],
        format: 'ORIGINAL',
        map: 'map-ortho',
        isLoading: false,
        submitted: false,
        printTicketsResponse: {},
        pdfURL: null
    }),
    computed: {
        printDisabled(){
            return this.selectedTickets.length === 0;
        },
        user() {
            return this.$store.getters.user;
        }
    },
    methods: {
        print() {
            this.printTicketsDialog = true;
        },
        async printTicket() {
            this.isLoading = true;
            this.submitted = true;
            let status = true;
            let param = {
                map: this.map,
                format: this.format,
                tickets: this.selectedTickets.map(item => item.TR_rowid),
            };
            let response = await webtmsBackend.printTickets('run', param);
            while(status) {
                let param = {
                    taskid: response.task.rowid,
                };
                this.printTicketsResponse = await webtmsBackend.printTickets('status', param);
                this.printTicketsResponse = this.printTicketsResponse.task;
                if(this.printTicketsResponse.success) {
                    var uid = this.printTicketsResponse.uid.replace('{', '').replace('}', '');
                    this.pdfURL = `${NEWTIN_HOST}/NewtinWeb/userdata/${this.user.account}$${uid}/${this.printTicketsResponse.task_output_ref}`;
                    this.isLoading = false;
                    break;
                }
            }
        },
        openPDFURL() {
            window.open(this.pdfURL, '_blank');
        },
        closeDialog() {
            this.printTicketsDialog = false;
            this.format = 'ORIGINAL',
            this.map = 'map-ortho';
            this.isLoading = false;
            this.submitted = false;
            this.printTicketsResponse = {};
            this.pdfURL = null;
        }
    }, 
};
</script>
<style>
#print-tickets-dialog .v-card__title .v-icon {
    background-color: #F0F6FF;
    margin-right: 12px;
    border-radius: 50%;
    width: 32px;
    height: 32px;    
}
#print-tickets-dialog .control-title {
    margin-top: 16px;
    font-weight: 500;
    font-size: 16px;
    color: var(--ll-text-brand);
}
#print-tickets-dialog .v-card__title span {
    font-size: 20px;
}
#print-tickets-dialog .v-radio label {
    color: var(--ll-text-brand);
}

.custom-dropdown {
    margin: 8px 0px !important;
}
.custom-list-item {
    min-height: 70px;
    margin: 16px 0px;
}
.custom-mobile-text-area {
    height: calc(100vh - 140px);;
}
</style>
